import type { MessageKey } from "./en";

/** Japanese UI catalog. Every key in {@link en} must be present. */
export const ja: Record<MessageKey, string> = {
  "app.title": "Rescript — テキストを編集するように動画を編集",
  "common.cancel": "キャンセル",
  "common.close": "閉じる",
  "common.delete": "削除",
  "common.download": "ダウンロード",
  "common.import": "インポート",
  "common.loading": "読み込み中",
  "common.remove": "削除",
  "common.restore": "復元",
  "common.retry": "もう一度試す",
  "common.searchOrCreate": "検索または作成…",
  "common.settings": "設定",
  "common.system": "システム",
  "common.tools": "ツール",
  "settings.appearance": "外観",
  "settings.light": "ライト",
  "settings.dark": "ダーク",
  "settings.interfaceLanguage": "表示言語",
  "settings.privacy": "プライバシー",
  "settings.helpImprove": "アプリの改善に協力",
  "settings.telemetryHelp": "匿名の機能利用統計とクラッシュレポートを送信します。",
  "settings.support": "サポート / フィードバック",
  "settings.reportIssue": "問題を報告",
  "settings.homepage": "ホームページ",
  "settings.github": "GitHub",
  "settings.followX": "X でフォロー",
  "model.transcriptSource": "文字起こしソース",
  "model.language": "言語",
  "model.transcriptLanguage": "文字起こし言語",
  "model.importTranscript": "文字起こしをインポート",
  "upload.recentProjects": "最近のプロジェクト",
  "upload.removeRecent": "最近の項目から削除",
  "upload.dropPrefix": "動画または音声ファイルをここにドロップ、または",
  "upload.browse": "参照",
  "upload.chooseTranscriptFirst": "上のメニューで文字起こしを選んでから、メディアをドロップしてください",
  "upload.willUseTranscript": "{name} を使用します · MP4、WebM、MOV、MP3、WAV など",
  "upload.mediaFormats": "MP4、WebM、MOV、MP3、WAV、M4A など",
  "upload.gettingReady": "準備中",
  "upload.gettingReadyHelp": "メディアエンジンを設定しています。これは一度だけ行われます。",
  "upload.unsupported": "このブラウザではエディターを実行できません",
  "upload.unsupportedHelp":
    "編集には SharedArrayBuffer が必要で、ページがクロスオリジン分離されている必要があります。HTTPS で最新の Chrome、Edge、Safari、Firefox をお試しください。",
  "upload.unsupportedSimd": "このデバイスではエディターを実行できません",
  "upload.unsupportedSimdHelp": "編集には WebAssembly SIMD が必要ですが、このプロセッサはサポートを報告していません。Windows on Arm の PC では Rescript を最新版に更新してください。現在のインストーラーにはエミュレーションで動作しないネイティブ Arm64 版が含まれています。",
  "upload.transcribeTitle": "文字起こし",
  "upload.transcribeText": "Whisper をローカルで使うか、SRT / VTT をインポートします。",
  "upload.editTitle": "編集",
  "upload.editText": "単語を選択して Delete キーを押すだけで編集できます。",
  "upload.exportTitle": "書き出し",
  "upload.exportText": "完成したカットを MP4 または M4A に書き出します。",
  "editor.chooseTranscript": "まずソースメニューから文字起こしファイルを選択してください。",
  "editor.chooseMedia": "動画または音声ファイルを選択してください。",
  "editor.undo": "取り消し (⌘Z)",
  "editor.redo": "やり直し (⇧⌘Z)",
  "editor.export": "書き出し",
  "topbar.startOver": "最初からやり直す",
  "transcript.replace": "SRT、VTT、JSON から文字起こしを置き換え",
  "transcript.header": "文字起こし",
  "transcript.wordDeleted": "{count} 語",
  "transcript.wordsDeleted": "{count} 語",
  "transcript.replaceConfirm": "現在の文字起こしをこのファイルで置き換えますか？",
  "transcript.invalidFile": "SRT、VTT、JSON の文字起こしファイルを選択してください。",
  "transcript.noSpeech": "音声が検出されませんでした。ファイルに音声があるか確認するか、文字起こしをインポートしてください。",
  "transcript.cut": "カット",
  "transcript.follow": "再生位置に追従",
  "transcript.hideDeleted": "削除済みの単語を隠す",
  "transcript.showDeleted": "削除済みの単語を表示",
  "transcript.correct": "修正",
  "transcript.scrollWithPlayhead": "再生位置に合わせてスクロール",
  "transcript.joinSplit": "クリップ分割 — クリックしてこれらのクリップを結合",
  "transcript.joinClips": "クリップを結合",
  "transcript.hesitation": "ためらい音を検出しました（文字起こしなし）— フィラー語を削除でカット",
  "transcript.textLabel": "文字起こしテキスト",
  "transcript.textHint": "矢印キーで単語を移動し、再生位置も移動します。Shift＋矢印キーで選択。Backspace または Delete で単語をカット、Enter で修正、Space で再生／一時停止、取り消しでカットを戻せます。",
  "transcript.textHesitation": "［ためらい］",
  "transcript.textCut": "カット：{text}",
  "transcript.textNothingToCut": "カットするものがありません",
  "transcript.textUndo": "取り消し",
  "transcript.textRedo": "やり直し",
  "tools.bulk": "文字起こしの一括クリーンアップ",
  "tools.removeFillers": "フィラー語を削除",
  "tools.removeFillersTitle": "動画からフィラー語（\"えー\"、\"あの\"、\"...\" など）をカット",
  "tools.restoreFillers": "フィラー語を復元",
  "tools.restoreFillersTitle": "カットしたすべてのフィラー語を戻す",
  "tools.removeSilences": "無音を削除",
  "tools.removeSilencesTitle": "動画から間や無音（{seconds}秒以上）をカット",
  "tools.restoreSilences": "無音を復元",
  "tools.restoreSilencesTitle": "カットしたすべての間を戻す",
  "timeline.removed": "{trimmed} 削除済み — 元の長さ {duration}",
  "timeline.back5": "5 秒戻る",
  "timeline.playPause": "再生 / 一時停止（スペース）",
  "timeline.forward5": "5 秒進む",
  "timeline.split": "分割",
  "timeline.splitTitle": "再生位置でクリップを分割 (S)",
  "timeline.splitDisabled": "分割するには、再生位置を残す範囲に移動してください",
  "timeline.delete": "削除",
  "timeline.deleteTitle": "選択したクリップを削除 (Delete)",
  "timeline.deleteDisabled": "削除するクリップをタイムラインで選択してください",
  "timeline.restore": "復元",
  "timeline.restoreTitle": "選択したカットを復元 (Delete)",
  "timeline.restoreDisabled": "復元するカットまたは無音区間をタイムラインで選択してください",
  "timeline.zoomOut": "縮小",
  "timeline.fit": "ウィンドウに合わせる",
  "timeline.zoomIn": "拡大 — 単語の端をドラッグしてタイミングを微調整",
  "timeline.joinClips": "これらのクリップを結合（分割を削除）",
  "timeline.trimStart": "クリップの開始をトリム",
  "timeline.trimEnd": "クリップの終了をトリム",
  "timeline.hesitationAdjust": "… ためらい音を検出 — 端をドラッグして調整するか、フィラー語を削除でカット",
  "timeline.hesitationCut": "… ためらい音を検出 — フィラー語を削除でカット",
  "timeline.dragTiming": "{word} — 端をドラッグしてタイミングを調整",
  "timeline.scrollZoom": "スクロールして拡大 / 縮小",
  "speaker.moveStart": "この話者が始まる位置をドラッグして移動",
  "speaker.moveLabel": "話者ラベルを移動",
  "speaker.options": "話者オプション",
  "speaker.change": "話者を変更",
  "speaker.rename": "話者名を変更",
  "speaker.renameAction": "名前を変更",
  "speaker.replace": "プロジェクト内で置き換え…",
  "speaker.removeProject": "プロジェクトから削除",
  "speaker.newName": "新しい名前",
  "speaker.find": "話者を検索…",
  "speaker.noMatches": "一致する話者がいません",
  "speaker.renameTo": "{current} を {next} に名前変更",
  "speaker.button": "話者",
  "speaker.search": "検索または作成…",
  "speaker.defaultName": "話者 {number}",
  "speaker.create": "「{name}」を作成",
  "export.title": "書き出し",
  "export.type": "書き出しタイプ",
  "export.video": "動画",
  "export.audio": "音声",
  "export.transcript": "文字起こし",
  "export.subtitles": "字幕",
  "export.videoUnavailable": "音声のみのプロジェクトでは動画を書き出せません",
  "export.noAudio": "このファイルには音声トラックがありません",
  "export.noWordsFirst": "先に文字起こしするか、文字起こしをインポートしてください",
  "export.format": "形式",
  "export.resolution": "解像度",
  "export.original": "元のまま",
  "export.plainText": "TXT",
  "export.markdown": "Markdown",
  "export.statOriginal": "元の長さ",
  "export.statCuts": "カット",
  "export.statEdited": "編集後",
  "export.includeTimestamps": "タイムスタンプを含める",
  "export.speakerLabels": "話者名を含める",
  "export.shortCues": "短い字幕（≤5秒）",
  "export.transcriptHelp": "話者ラベル付きテキスト。カット部分は除外されます。",
  "export.transcriptHelpTimestamps":
    "話者ラベル付きテキスト。カット部分は除外され、各発話は編集後タイムラインの時刻で始まります。",
  "export.transcriptHelpPdf":
    "PDF はラテン系の標準フォントを使います。CJK など完全な Unicode には DOCX を推奨します。",
  "export.subtitlesHelp":
    "SRT と VTT は編集後のタイムライン（カット適用済み）を使用します。JSON は再インポート用に完全な単語リストを保持します。",
  "export.subtitlesHelpShortCues":
    "SRT と VTT は編集後のタイムライン（カット適用済み）を使い、短い文単位の字幕（≤5秒）に分割します。JSON は再インポート用に完全な単語リストを保持します。",
  "export.encodingHelp": "ffmpeg.wasm で再エンコード中 — 長いファイルは時間がかかります。",
  "export.reexport": "最新の編集で再書き出し",
  "export.rendering": "ブラウザでレンダリング中…",
  "export.downloadFile": "{name} をダウンロード",
  "export.saveFile": "{name} を保存…",
  "export.saving": "保存中…",
  "export.saveDialogTitle": "書き出しを保存",
  "export.savedAs": "{name} として保存しました",
  "export.showInFinder": "Finder で表示",
  "export.showInExplorer": "エクスプローラーで表示",
  "export.showInFolder": "フォルダで表示",
  "export.renderingNative": "レンダリング中…",
  "export.encodingHelpNative": "ffmpeg で再エンコード中 — 長いファイルは時間がかかります。",
  "export.downloadFormat": ".{format} をダウンロード",
  "export.exportFormat": "{format} を書き出し",
  "export.timeline": "タイムライン",
  "export.timelineTitle": "NLE / DAW シーケンスを書き出す（Resolve、Premiere、Final Cut、Pro Tools、Reaper、Blender）",
  "export.nle": "形式",
  "export.frameRate": "フレームレート",
  "export.timelineHelp":
    "シーケンスは元のメディアをファイル名で参照します — 読み込み後に NLE で再リンクしてください。",
  "export.timelineHelpAaf": "Pro Tools / Logic 用 AAF（メタデータのみ）。",
  "export.timelineHelpFcpx": "Final Cut Pro FCPXML。",
  "export.timelineHelpPremiere": "Adobe Premiere Pro XML（xmeml）。",
  "export.timelineHelpResolve": "DaVinci Resolve XML（xmeml）。",
  "export.timelineHelpReaper": "Reaper プロジェクト（.rpp）。",
  "export.timelineHelpSamplitude":
    "Samplitude EDL（.edl）— Reaper でも直接開けます。",
  "export.timelineHelpBlender":
    "Blender の動画編集プロジェクト（.blend、Blender 5.2 以降）— 元のメディアと同じフォルダーに保存してください。",
  "export.aafOverCap":
    "この編集には {count} クリップあります。AAF は最大 {max} までです。Resolve、Premiere、Final Cut、Reaper、または Samplitude EDL を使ってください。",
  "export.preparing": "準備中…",
  "import.reading": "文字起こしを読み込み中…",
  "import.importing": "インポート中…",
  "import.failed": "インポートに失敗しました",
  "import.readingFile": "ファイルを読み込み中…",
  "import.chooseFileShort": "ファイルを選択…",
  "import.chooseFile": "SRT、VTT、JSON の文字起こしを選択",
  "import.selected": "{name} を選択しました",
  "banner.faster": "文字起こしと書き出しをもっと速くしますか？",
  "banner.getDesktop": "Rescript デスクトップアプリを入手",
  "banner.downloadFor": "{platform} 版をダウンロード",
  "banner.dismiss": "閉じる",
  "social.githubRepo": "GitHub リポジトリ",
  "social.discordServer": "Discord サーバー",
  "social.xProfile": "X プロフィール",
  "globalError.title": "Rescript — 問題が発生しました",
  "globalError.heading": "問題が発生しました",
  "globalError.body":
    "エディターで予期しないエラーが発生しました。保存済みプロジェクトはこのデバイスに残っています。再読み込みすれば復元されるはずです。",
  "progress.loadingMedia": "メディアを読み込み中…",
  "progress.loadingMediaEngine": "メディアエンジンを読み込み中…",
  "progress.extractingAudio": "音声を抽出中…",
  "progress.preparingMedia": "メディアを準備中…",
  "progress.loadingSpeechModel": "音声モデルを読み込み中…",
  "progress.loadingSpeechCache": "キャッシュから音声モデルを読み込み中…",
  "progress.downloadingSpeech": "音声モデルをダウンロード中…",
  "progress.gpuFallback": "GPU が中断されました — CPU で続行します…",
  "progress.detectingSpeech": "音声を検出中…",
  "progress.transcribing": "文字起こし中…",
  "progress.loadingAlignCache": "キャッシュからアラインメントモデルを読み込み中…",
  "progress.downloadingAlign": "アラインメントモデルをダウンロード中…",
  "progress.aligning": "単語を整列中…",
  "progress.speakers": "話者を識別中…",
  "error.selectModel": "文字起こしに使う音声モデルを選択してください。",
  "error.workerCrashed": "文字起こしワーカーがクラッシュしました。",
  "error.mediaEngineNetwork": "メディアエンジンを読み込めませんでした — 接続が切れました。インターネット接続を確認して、もう一度お試しください。",
  "error.mediaEngineStalled": "メディアエンジンが応答しなくなったため再起動しました。他のアプリやタブを閉じてメモリを空けてから、もう一度お試しください。",
  "error.mediaEngineNotReady": "メディアエンジンの準備がまだできていません — ページを再読み込みして、もう一度お試しください。",
  "error.simdUnsupported": "このプロセッサはメディアエンジンに必要な WebAssembly SIMD をサポートしていません。Windows on Arm の PC では Rescript を最新版に更新してください。現在のインストーラーにはエミュレーションで動作しないネイティブ Arm64 版が含まれています。",
  "error.processFile": "このファイルを処理できませんでした。",
  "error.extractAudio": "このファイルから音声を抽出できませんでした。",
  "error.nothingToExport": "すべて削除されています — 書き出すものがありません。",
  "error.videoExport": "動画のレンダリング中に書き出しに失敗しました。",
  "error.audioExport": "音声のレンダリング中に書き出しに失敗しました。",
  "error.exportSave": "書き出したファイルを保存できませんでした。",
  "error.diskFull": "ディスクの空き容量が足りません。空き容量を確保してからもう一度お試しください。",
  "error.export": "書き出しに失敗しました。",
  "error.timelineExport": "タイムラインの書き出しに失敗しました。",
  "error.timelineEmpty": "タイムラインに配置するものがありません。",
  "error.aafTemplate": "AAF 書き出しテンプレートを読み込めませんでした。",
  "error.emptyTranscript": "その文字起こしファイルは空です。",
  "error.noTimedWords": "その文字起こしにタイミング付きの単語がありません。",
  "error.parseJson": "その JSON 文字起こしを解析できませんでした。",
  "error.jsonShape": 'JSON は単語配列、または { "words": [...] } である必要があります。',
  "error.noWords": "書き出す単語がありません。",
  "error.projectMissing": "そのプロジェクトはもう保存されていません。",
  "error.openProject": "そのプロジェクトを開けませんでした。",
  "error.removeProject": "そのプロジェクトを削除できませんでした。",
  "error.readTranscript": "その文字起こしを読み込めませんでした。",
  "error.clearRecent": "最近のプロジェクトを消去できませんでした。",
  "error.modelDownload":
    "音声モデルのダウンロードを完了できませんでした — 接続が切れました。インターネット接続を確認してもう一度お試しください。完了した部分は保持されます。",
  "error.gpuReset": "GPU がリセットされたため文字起こしが中断されました（画面ロック後によく起きます）。もう一度お試しください。",
  "confirm.clearRecent": "最近のプロジェクトをすべて削除しますか？保存済みの編集も削除されます。",
};
